// extracted by mini-css-extract-plugin
export default {"container":"Data_container__b0SP8","data":"Data_data__KBdCi","field":"Data_field__-pztX"};